export { Heading, HeadingType } from './Heading';
export { Span } from './Span';
export { Paragraph } from './Paragraph';
export { Anchor } from './Anchor';
export { Strong } from './Strong';
